<template>
	<div>
			<div class="container container--small pdt-50 ">
				<div class="pdl-24 pdr-24">
					<div class="t-headline10 font-b  mgb-8">{{$t('364')}}</div>
					<div class="body1 font-r t-color-bodyGrayA">
						{{$t('365')}}
					</div>
					<form @submit.prevent="" novalidate>
					<div class="mgt-40 mgb-8">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"

							:class="(submitState && searchValueInvalidCheck) || responseError ? 'mdc-text-field--invalid mdc-text-field--invalid' : ''"
							id="searchValueEl"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="password-message">{{$t('366')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" type="text" aria-labelledby="password-message"
								id="searchValue"
								name="searchValue"
								v-model="searchValue"
								v-validate="'required'"
								ref="searchValue"
								maxlength="50"
								required
							>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line">
							<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
								id="my-helper-id" aria-hidden="true">
								<span v-show="(submitState && searchValueInvalidCheck) || responseError">
									{{$t('954')}}
								</span>
							</div>
						</div>
					</div>
					<div class="mgt-30">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"
							type="submit" @click="searchInfo" @keypress="searchInfo" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('367')}}</span>
						</button>
						<button class="mdc-button bg-white t-color-secondaryBtnText " @click="cancelFindPw()" @keypress="cancelFindPw()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('368')}}</span>
						</button>
					</div>
					</form>
				</div>
			</div>
	</div>
</template>
<script>
/**
 * 비밀번호 재설정 Step1 컴포넌트 (reset password Step1 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '@/mixins/findId.js'

export default {
	data() {
		return {
			externalAuthCode: false,
			searchValue: '',
			searchValueTextField: '',
			submitState: false,
			responseError:false
		}
	},

	mixins: [findIdMixin],

	computed : {

		// searchValue 유효성 Check(validation check searchValue)
		searchValueInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('searchValue')) {
					returnValue = true
				} else {
					returnValue = false
				}
			}

			this.searchValueTextField.valid === !returnValue ? '' : this.searchValueTextField.valid = !returnValue
			return returnValue
		}
	},

	mounted() {
		this.setMaterialUi()
		//Store 초기화(init store)
		this.INIT_FINDPW_STORE()
		this.$refs.searchValue.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('findPw', ['SET_STEP1', 'SET_AUTH_METHODS', 'INIT_FINDPW_STORE']),

		setMaterialUi() {
		window.mdc.autoInit();
		const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			this.searchValueTextField = new MDCTextField(document.querySelector('#searchValueEl'))
			this.searchValueTextField.useNativeValidation = false
			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// search information
		searchInfo() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					// this.callLoginApi(loginType)
					let params = {
						value: this.searchValue,
						firstName: '',
						lastName: '',
						code: '',
					}

					this.SET_STEP1(params)
					// 패스워드 찾을 인증 수단 조회(get find password auth methods)
					findApi.findByInfo(params).then((response) => {
						let responseData = response.data.data.sort((a,b) => (a.findWay.value < b.findWay.value) ? 1 : ((b.findWay.value < a.findWay.value) ? -1 : 0))
						this.SET_AUTH_METHODS(responseData)
					//	this.responseError = false
						if (responseData.length) {
							this.$router.push({
								name: 'FindPwStep2'
							})
						}else {
						//	this.responseError = true
							// this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
							this.$snackOpen({
								contents: this.$t('374') +' '+ this.$t('305'),
								btnDisplayYN: false
								// btnDisplay:this.$t('Common.00001')
							}).then(() => {})
						}
					}).catch((err) => {
					//	this.responseError = true
						let responseData = err.response.data.meta
						// this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
						// this.$snackOpen({contents:'검색 결과가 없습니다. 검색하신 이메일 주소 또는 휴대폰 번호를 확인 후 다시 시도해주세요.'}).then(() => {})
						this.$snackOpen({
							contents: this.$t('374') +' '+ this.$t('305'),
							btnDisplayYN: false
						}).then(() => {})
					})
				}else {
				}
				this.$refs.searchValue.focus()
			})
		}
	},



}
</script>
